'use strict';

/* global $ */

import { Ajax } from 'utils/ajax';
import { fancybox } from 'settings';

import { Form } from './ajax-form/form';


let settings = {
    formSelector: '.js-ajax-form__form',
    linkSelector: '.js-ajax-form__link',
    fancybox: {},
    form: {}
};


class AjaxForm {
    constructor(options) {
        this.opt = $.extend(true, {}, settings, options);
        this.init();
    }
    init() {
        console.log('[ AjaxForm/init ]');

        let self = this;

        $(document.body).on('click', this.opt.linkSelector, function(e) {
            e.preventDefault();

            let $el = $(this);
            self.getForm($.extend({}, { href: $el.attr('href') }, $el.data()));
        });

        $(this.opt.formSelector).each(function() {
            if (!this.__ajax_form) {
                this.__ajax_form = new Form(this, self.opt.form);
            }
        });

        $(window).on('main:initAjaxForm', () => {
            $(this.opt.formSelector).each(function() {
                if (!this.__ajax_form) {
                    this.__ajax_form = new Form(this, self.opt.form);
                }
            });
        });

        $(window).on('ajaxForm:form:goal', (e, data) => {
            $(window).trigger('ajaxForm:goal', data);
        });
    }
    getForm(params) {
        console.log('[ AjaxForm/getForm ]', params);

        Ajax.get('get_form', params).then((data) => {
            if (data.ok) {
                this.showForm(data.content);
            } else {
                console.error('Can\'t get form');
            }
        }).catch(function(error) {
            throw new Error(error);
        });
    }
    showForm(content) {
        console.log('[ AjaxForm/showForm ]');

        let self = this;

        $(content).appendTo('body');
        let form = $('#Modal').find(self.opt.formSelector).get(0);
        form.__ajax_form = new Form(form, self.opt.form);
        let fModal = new bootstrap.Modal(document.getElementById('Modal'), {
            keyboard: false
        });
        fModal.show();
        let ModalEl = document.getElementById('Modal');
        ModalEl.addEventListener('hidden.bs.modal', function(event) {
            $('#Modal').remove();
        })


        /*
        $.fancybox($.extend(true, {}, fancybox, this.opt.fancybox, {
            type: 'html',
            content: content,
            afterShow: function() {
                let form = this.inner.find(self.opt.formSelector).get(0);
                form.__ajax_form = new Form(form, self.opt.form);
            }
        }));
        */
    }
}


export {
    AjaxForm
};
